import { useEffect } from "react";
// react-router-dom components

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "../components/MKBox";

import colors from "../assets/theme/base/colors";
// Image
import bgImage from "../assets/images/General/impression-jurong-innovation-district-1455x731.jpg";
import DashboardTitle from "../pageSections/DashboardTitles.js/DashboardTitle";
import PageLayout from "../layouts/dashboards";
import AppIconButton from "../components/AppIconButton/ApplicationIconButton";
import ReleasedApplications from "../common/ReleasedApplications";
import JmmIcon from "../assets/images/General/JmmIcon.png";
import MDBox from "../components/MDBox";
import { useMediaQuery } from "@mui/material";
import breakpoints from "../assets/theme/base/breakpoints";
import AppHost from "../common/AppHost";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Axios_ValidateToken } from "../api/axiosFunctions";
import { clearUser } from "../redux/features/user/userSlice";
import { updateAppHost } from "../redux/features/app/appSlice";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//        NOT IN USE
/** Un-Authenticated Page - View FEMS2.0 Applications  */
function Page() {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  /* #region useEffect - Token Validation */
  useEffect(() => {
    if ((user.token !== "") & (user.token !== undefined)) ValidateTokenOnLoad();
  }, []);

  const ValidateTokenOnLoad = async () => {
    try {
      await Axios_ValidateToken(user.token);
    } catch (ex) {
      dispatch(clearUser());
    } finally {
    }
  };

  /* #endregion */

  const isMediumScreenAndAbove = useMediaQuery(
    `(min-width:${breakpoints.values.md}px)`
  );

  /** Difference wrapper for XS or MD screen */
  const Appropriate_Wrapper = (children) => {
    return (
      <>
        {isMediumScreenAndAbove ? (
          <> {children}</>
        ) : (
          <Grid
            container
            pb={4}
            placeitems={"center"}
            alignItems={"center"}
            justifyContent={"center"}
            spacing={2}
          >
            {children}
          </Grid>
        )}
      </>
    );
  };

  const Applications = () => {
    var _apps = [];
    ReleasedApplications.map((element) => {
      // if (element.appCategory === "public") {
      _apps.push(
        <Grid item xxs={6} xs={4} key={element.appTag}>
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            px={2}
            bgColor={"primary.main"}
            width="100%"
            sx={{ paddingX: { xs: 0.75, md: 2 } }}
          >
            <AppIconButton
              isShowToolTip
              avatarIcon={element.appIcon}
              avatarTooltip={element.appDescription}
              avatarTag={element.appShortTag}
              avatarTagColor={colors.white.main}
              appHref={element.appUrl}
              onClick={
                ((user?.token ?? "") === "" || user.token === undefined) &&
                element.appCategory === "private"
                  ? () => {
                      dispatch(
                        updateAppHost(AppHost[element.appShortTag].code)
                      );
                      navigate(
                        "login?app=" + AppHost[element.appShortTag].param
                      );
                    }
                  : undefined
              }
              isShowAppTags={true}
            />
          </MDBox>
        </Grid>
      );

      {
        /* <AppIconButton
                    p={3}
                    avatarIcon={JmmIcon}
                    avatarTag={"FEMS 2.0"}
                    avatarTagColor={colors.white.main}
                    appHref={"/login"}
                  /> */
      }
      // }
    });

    return _apps;
  };

  return (
    <PageLayout padding={0} noCompressed>
      <>
        <MKBox
          minHeight="30vw"
          maxHeight="600px"
          width="100%"
          pb={10}
          sx={{
            backgroundImage: ({
              functions: { linearGradient, rgba },
              palette: { gradients },
            }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "left",
            display: "grid",
            placeitems: "center",
            alignItems: "end",
          }}
        >
          <Grid
            item
            xs={12}
            md={12}
            pb={3}
            sx={{ display: { xs: "flex", md: "flex" } }}
          >
            <MKBox
              p={2}
              pl={7}
              pt={15}
              sx={({ breakpoints }) => ({
                [breakpoints.down("md")]: {
                  paddingLeft: "0",
                  pl: "1",
                },
              })}
            >
              <DashboardTitle />
            </MKBox>
          </Grid>
        </MKBox>

        <MKBox
          minHeight="40vh"
          maxHeight="110vh"
          width="100%"
          sx={{
            bgcolor: colors.JTC.grey2a,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeitems: "center",
            alignItems: "flex-start",
          }}
        >
          <Grid
            item
            xs={12}
            md={11}
            mt={-12}
            pb={20}
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ display: { xs: "flex", md: "flex" } }}
          >
            <MDBox
              bgColor={colors.JTCElectricBlue}
              mx={3}
              py={2}
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={({ breakpoints }) => ({
                backgroundImage: ({
                  functions: { linearGradient, rgba },
                  palette: { gradients },
                }) =>
                  `${linearGradient(
                    rgba(gradients.dark.main, 0.4),
                    rgba(gradients.dark.state, 0.2)
                  )} `,
                opacity: "95%",
                width: "95%",
                maxWidth: "120rem",
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "grid",
                borderRadius: "30px",
                placeitems: "top",
                [breakpoints.down("md")]: {
                  backgroundColor: colors.JTC.grey3a,
                  alignItems: "center",
                  justifyContent: "center",
                },
              })}
            >
              <MDBox
                direction="row"
                display="flex"
                sx={{ overflow: "hidden", overflowX: "auto" }}
              >
                {Appropriate_Wrapper(Applications())}
              </MDBox>
            </MDBox>

            {/* <ApplicationsBox /> */}
          </Grid>
          {/* {xs_layout()} */}
        </MKBox>
      </>
    </PageLayout>
  );
}

export default Page;
